import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { message } from 'antd';
import { MessageOutlined, CalendarOutlined, MailOutlined } from '@ant-design/icons';
import '../styles/dashboardCardTokens.css';
import './Support.css';
import SupportTicketModal from './SupportTicketModal';

const CALENDLY_URL = 'https://calendly.com/hooptie/hooptie-strategy-call';

function openCalendlyPopup() {
  if (typeof window.Calendly !== 'undefined') {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    script.onload = () => {
      if (window.Calendly) window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    };
    document.body.appendChild(script);
  }
}

const SUPPORT_OPTIONS = [
  {
    key: 'chat',
    icon: <MessageOutlined />,
    title: 'Chat with Support',
    description: 'Live chat with our support team.',
    buttonLabel: 'Start Chat',
    disabled: true,
    onClick: () => {
      message.info('Chat coming soon.');
    },
  },
  {
    key: 'call',
    icon: <CalendarOutlined />,
    title: 'Book a Strategy Call',
    description: 'Schedule a 15-minute optimization call.',
    buttonLabel: 'Pick a Time',
    onClick: openCalendlyPopup,
  },
  {
    key: 'ticket',
    icon: <MailOutlined />,
    title: 'Submit a Ticket',
    description: 'Reach out via our support ticket form.',
    buttonLabel: 'Submit Ticket',
    isTicket: true,
  },
];

const Support = () => {
  const [ticketModalOpen, setTicketModalOpen] = useState(false);

  return (
    <div className="support-page">
      <header className="support-header">
        <h1 className="support-title">Support</h1>
        <p className="support-subtitle">How can we assist you today?</p>
      </header>

      <div className="support-cards">
        {SUPPORT_OPTIONS.map((opt) => (
          <div key={opt.key} className="support-card">
            <div className="support-card-icon">{opt.icon}</div>
            <h3 className="support-card-title">{opt.title}</h3>
            <p className="support-card-desc">{opt.description}</p>
            <button
              type="button"
              className="support-card-btn"
              disabled={opt.disabled}
              onClick={opt.disabled ? undefined : (opt.isTicket ? () => setTicketModalOpen(true) : opt.onClick)}
            >
              {opt.buttonLabel}
            </button>
          </div>
        ))}
      </div>

      <footer className="support-footer">
        <span className="support-footer-copyright">© 2026 Hooptie</span>
        <div className="support-footer-links">
          <NavLink to="/terms-of-service">Terms</NavLink>
          <NavLink to="/privacy-policy">Privacy</NavLink>
        </div>
      </footer>

      <SupportTicketModal
        open={ticketModalOpen}
        onClose={() => setTicketModalOpen(false)}
      />

    </div>
  );
};

export default Support;
